import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, Event , RouterOutlet } from '@angular/router';
import { HeaderComponent } from "./shared/header/header.component";
import { FooterComponent } from "./shared/footer/footer.component";
import { LoaderService } from './shared/loader/loader.service';
import { LoaderComponent } from "./shared/loader/loader.component";
import { CommonModule } from '@angular/common';
import { environment } from './environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, LoaderComponent,CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {

  title = 'MALtechApp';

  isLoading = false;

  isSignupPage = false;

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private dom: Document
  ) {

    this.router.events.subscribe((event: Event) => {

      if (event instanceof NavigationStart) {

        this.showLoader();

      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {

        this.hideLoader();
      }

      // Detect signup page
      if (event instanceof NavigationEnd) {

        this.isSignupPage =
          event.urlAfterRedirects.startsWith('/sign-up');
      }

    });
  }

  private showLoader() {
    this.isLoading = true;
  }

  private hideLoader() {

    setTimeout(() => {
      this.isLoading = false;
    }, 1000);

  }

  ngOnInit(): void {

        // ==========================================
    // Dynamic SEO Robots Meta Tags
    // ==========================================

    const robotsContent = environment.production
      ? 'index, follow'
      : 'noindex, nofollow';

    const botContent = environment.production
      ? 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1'
      : 'noindex, nofollow, max-snippet:-1, max-image-preview:large, max-video-preview:-1';

    this.dom
      .querySelector('meta[name="robots"]')
      ?.setAttribute('content', robotsContent);

    this.dom
      .querySelector('meta[name="googlebot"]')
      ?.setAttribute('content', botContent);

    this.dom
      .querySelector('meta[name="bingbot"]')
      ?.setAttribute('content', botContent);


    const baseUrl = environment.baseUrl.replace(/\/$/, '');

    const schema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "MALtech",
      "url": baseUrl,
      "logo": `${baseUrl}/assets/images/logo.png`,
      "sameAs": [
        "https://facebook.com/MALtechs",
        "https://linkedin.com/company/maltechs"
      ],
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "IN"
      }
    };

    const script = this.dom.createElement('script');

    script.type = 'application/ld+json';

    script.text = JSON.stringify(schema);

    this.dom.head.appendChild(script);

     // ==========================================
  // Dynamic Social Meta Tags
  // ==========================================

  this.updateSocialMetaTags();
  }

  private updateSocialMetaTags(): void {

  const websiteUrl = environment.websiteUrl.replace(/\/$/, '');

  // ==========================================
  // Open Graph Meta Tags
  // ==========================================

  this.dom
    .querySelector('meta[property="og:url"]')
    ?.setAttribute('content', `${websiteUrl}/`);

  this.dom
    .querySelector('meta[property="og:image"]')
    ?.setAttribute(
      'content',
      `${websiteUrl}/assets/images/og-banner.jpg`
    );


  // ==========================================
  // Twitter Meta Tags
  // ==========================================

  this.dom
    .querySelector('meta[name="twitter:url"]')
    ?.setAttribute('content', `${websiteUrl}/`);

  this.dom
    .querySelector('meta[name="twitter:image"]')
    ?.setAttribute(
      'content',
      `${websiteUrl}/assets/images/og-banner.jpg`
    );
}
}